import React, { useRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import styles from './styles.module.scss';

export interface IProps {
  closable?: boolean;
  maxDate?: Date;
  minDate?: Date;
  selected: Nullable<Date>;
  [key: string]: any;
}

const DatePicker = (props: IProps) => {
  const pickRef = useRef<ReactDatePicker>(null);

  const closeDatePicker = () => {
    pickRef.current!.setOpen(false);
  };

  const {
    closable,
    children,
    maxDate,
    minDate,
    selected,
    onChange,
    ...otherProps
  } = props;
  return (
    <ReactDatePicker
      disabledKeyboardNavigation
      ref={pickRef}
      previousMonthButtonLabel=""
      nextMonthButtonLabel=""
      inline
      useWeekdaysShort
      fixedHeight
      maxDate={maxDate}
      minDate={minDate}
      selected={selected}
      onChange={onChange}
      {...otherProps}
    >
      {closable && (
        <span onClick={closeDatePicker} className={styles['close-button']}>
          Close
        </span>
      )}
      {children}
    </ReactDatePicker>
  );
};

export default DatePicker;
